import { ApiComponents } from "./ComponentsMapper";
import { LayoutItem, LayoutSlot } from "@/app/(custom-header)/winners-template/LayoutTokens";

export const resolveSlots = (
  components: ApiComponents[],
  slots: Partial<Record<LayoutSlot, (string | LayoutItem)[]>>
): Partial<Record<LayoutSlot, LayoutItem[]>> => {
  return Object.fromEntries(
    Object.entries(slots).map(([slot, items]) => [
      slot,
      items?.map(item => {
        if (typeof item === "string") {
          return components.find(c => c.id === item) ?? null;
        }
        return item;
      }) ?? [],
    ])
  ) as Partial<Record<LayoutSlot, LayoutItem[]>>;
};
